export enum Breakpoint {
	Small = '40em',
	Medium = '52em',
	Large = '64em',
}
